import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { BedRockAPIChatBotMessageResponseSchema } from "../schemas";
export const url = () => {
    return environment() === "PROD"
        ? "https://middleware.prod.farther.com/chatbot/v1/sendMessage"
        : "https://middleware.uat.farther.com/chatbot/v1/sendMessage";
};
const postSendMessage = async (body, idempotencyKey, config) => {
    const { data } = await axios.post(url(), body, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Idempotency-key": idempotencyKey,
        },
    });
    const decoded = BedRockAPIChatBotMessageResponseSchema.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[postSendMessage] Could not parse response";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
export default postSendMessage;
//# sourceMappingURL=postSendMessage.js.map